// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function UserIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.865 26.5c-1.904-3.291-4.837-5.651-8.261-6.77a9 9 0 1 0-9.208 0c-3.424 1.117-6.357 3.477-8.261 6.77a1 1 0 1 0 1.731 1C7.221 23.43 11.384 21 16 21c4.616 0 8.779 2.43 11.134 6.5a.998.998 0 0 0 1.379.389 1 1 0 0 0 .352-1.389ZM9 12a7 7 0 1 1 7 7 7.008 7.008 0 0 1-7-7Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
